{
  "auth.changePassword.confirmPasswordLabel": "Confirm New Password",
  "auth.changePassword.confirmPasswordPlaceholder": "Re-enter your new password",
  "auth.changePassword.currentPasswordLabel": "Current Password",
  "auth.changePassword.currentPasswordPlaceholder": "Enter your current password",
  "auth.changePassword.error.currentPasswordIncorrect": "Current password is incorrect.",
  "auth.changePassword.error.passwordMismatch": "Passwords do not match.",
  "auth.changePassword.error.samePassword": "New password must be different from current password.",
  "auth.changePassword.headerTitle": "Change Password",
  "auth.changePassword.newPasswordLabel": "New Password",
  "auth.changePassword.newPasswordPlaceholder": "Enter your new password",
  "auth.changePassword.submit": "Change Password",
  "auth.changePassword.subtitle": "Your account has a temporary password. Please set a new password to continue.",
  "auth.changePassword.success": "Password changed successfully.",
  "auth.changePassword.title": "Change Password",
  "auth.forgotPassword.emailLabel": "Email address",
  "auth.forgotPassword.emailPlaceholder": "you@example.com",
  "auth.forgotPassword.goBack": "Go Back",
  "auth.forgotPassword.headerTitle": "Forgot Password",
  "auth.forgotPassword.sendCode": "Send Code",
  "auth.forgotPassword.subtitle": "Enter the email address associated with your account and we'll send you a code to reset your password.",
  "auth.forgotPassword.title": "Forgot Password",
  "auth.login.emailLabel": "Email address",
  "auth.login.emailPlaceholder": "you@example.com",
  "auth.login.error.expiredOtp": "This code has expired. Please request a new one.",
  "auth.login.error.invalidEmail": "Please enter a valid email address.",
  "auth.login.error.invalidToken": "Invalid or expired invite link.",
  "auth.login.error.wrongPassword": "Incorrect email or password.",
  "auth.login.forgotPassword": "Forgot password?",
  "auth.login.headerTitle": "Log In",
  "auth.login.heading": "Welcome back",
  "auth.login.noSms": "We never send codes via SMS.",
  "auth.login.otpLabel": "One-time code",
  "auth.login.otpPlaceholder": "Enter the code sent to your email",
  "auth.login.otpSent": "A code has been sent to your email.",
  "auth.login.passwordLabel": "Password",
  "auth.login.passwordPlaceholder": "Enter your password",
  "auth.login.sendOtp": "Send code",
  "auth.login.submit": "Log In",
  "auth.login.subtitle": "Log in to securely access your application",
  "auth.login.tabOtp": "Email Code",
  "auth.login.tabPassword": "Password",
  "auth.login.title": "Log In",
  "auth.otp.error.expired": "This code has expired. Please request a new one.",
  "auth.otp.error.invalid": "The code you entered is incorrect.",
  "auth.otp.getHelp": "Get Help",
  "auth.otp.headerTitle": "Verification",
  "auth.otp.heading": "Verify your email",
  "auth.otp.resend": "Resend code",
  "auth.otp.resendCooldown": "Resend in {seconds}s",
  "auth.otp.resendPrompt": "Didn't get the code?",
  "auth.otp.submit": "Log In",
  "auth.otp.subtitle": "Enter the 6-digit code sent to your email",
  "auth.otp.title": "Verification",
  "auth.otpVerification.didntGetCode": "Didn't get the code?",
  "auth.otpVerification.error.expiredCode": "This code has expired. Please request a new one.",
  "auth.otpVerification.error.invalidCode": "The code you entered is incorrect.",
  "auth.otpVerification.getHelp": "Get Help",
  "auth.otpVerification.headerTitle": "Verification",
  "auth.otpVerification.resendCode": "Resend code",
  "auth.otpVerification.submit": "Log In",
  "auth.otpVerification.subtitle": "Enter the 6-digit code sent to your email",
  "auth.otpVerification.title": "Verify your email",
  "auth.resetPassword.confirmPasswordLabel": "Confirm New Password",
  "auth.resetPassword.confirmPasswordPlaceholder": "Re-enter your new password",
  "auth.resetPassword.contactSupport": "Contact Support",
  "auth.resetPassword.needHelp": "Need help?",
  "auth.resetPassword.newPasswordLabel": "New Password",
  "auth.resetPassword.newPasswordPlaceholder": "Enter your new password",
  "auth.resetPassword.submit": "Reset Password",
  "auth.resetPassword.subtitle": "Create a strong password that you haven't used before.",
  "auth.resetPassword.success": "Your password has been reset successfully.",
  "auth.resetPassword.title": "Reset Password",
  "auth.resetPassword.verifyEmail.contactSupport": "Contact Support",
  "auth.resetPassword.verifyEmail.needHelp": "Need help?",
  "auth.resetPassword.verifyEmail.heading": "Verify your email",
  "auth.resetPassword.verifyEmail.submit": "Verify Code",
  "auth.resetPassword.verifyEmail.subtitle": "Enter the 6-digit code sent to your email to verify your identity.",
  "auth.register.alreadyHaveAccount": "Already have an account? Sign In",
  "auth.register.alreadyHaveAccountLabel": "Log In",
  "auth.register.alreadyHaveAccountPrefix": "Already have an account?",
  "auth.register.emailLabel": "Email address",
  "auth.register.emailReadOnly": "Your email is pre-filled from your invitation and cannot be changed.",
  "auth.register.error.invalidInvite": "This invitation link is invalid or has already been used.",
  "auth.register.error.passwordComplexity": "Password must include uppercase, lowercase, and a number.",
  "auth.register.error.passwordTooLong": "Password must not exceed 32 characters.",
  "auth.register.error.passwordTooShort": "Password must be at least 8 characters.",
  "auth.register.firstNameLabel": "First name",
  "auth.register.firstNamePlaceholder": "First name",
  "auth.register.firstNameRequired": "First name is required.",
  "auth.register.headerTitle": "Sign Up",
  "auth.register.infoPanelStep1Desc": "Provide the details of who represents your business legally.",
  "auth.register.infoPanelStep1Title": "Legal Representative & Contact",
  "auth.register.infoPanelStep2Desc": "Share your official registration details, exactly as they appear on legal documents.",
  "auth.register.infoPanelStep2Title": "Core Business Information",
  "auth.register.infoPanelStep3Desc": "Define what you sell and confirm your compliance credentials.",
  "auth.register.infoPanelStep3Title": "Product & Compliance Information",
  "auth.register.infoPanelStep4Desc": "Securely set up your payment details so you can receive payments.",
  "auth.register.infoPanelStep4Title": "Financial Settlement",
  "auth.register.infoPanelStep5Desc": "Finally, define your brand identity and brand visuals.",
  "auth.register.infoPanelStep5Title": "Branding & Localization",
  "auth.register.infoPanelTitle": "Here's what we'll need to review your application",
  "auth.register.lastNameLabel": "Last name",
  "auth.register.lastNamePlaceholder": "Last name",
  "auth.register.lastNameRequired": "Last name is required.",
  "auth.register.passwordHint": "8–32 characters, at least one uppercase, one lowercase, and one number.",
  "auth.register.passwordLabel": "Create Password",
  "auth.register.passwordPlaceholder": "Create a password",
  "auth.register.privacyLink": "Privacy Policy",
  "auth.register.questionsText": "Got any questions about the application requirements?",
  "auth.register.submit": "Create account",
  "auth.register.subtitle": "Setup your account to begin the vendor application process.",
  "auth.register.termsLink": "Terms of Service",
  "auth.register.termsMid": " and ",
  "auth.register.termsPrefix": "By clicking on \"Create Account\", you agree to AladdinMiles ",
  "auth.register.termsText": "By clicking on \"Create Account\", you agree to AladdinMiles {termsLink} and {privacyLink}.",
  "auth.register.title": "Create Account",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.changeFile": "Change",
  "common.clearSearch": "Clear search",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.contactSupport": "Contact Support",
  "common.disabled": "Disabled",
  "common.error.generic": "Something went wrong. Please try again.",
  "common.error.network": "Network error. Please check your connection.",
  "common.error.unauthorized": "You are not authorized to perform this action.",
  "common.error.uploadRequired": "File upload is required",
  "common.footer.copyright": "© 2026 AladdinMiles",
  "common.footer.helpCenter": "Help Center",
  "common.footer.privacyPolicy": "Privacy Policy",
  "common.footer.termsOfService": "Terms of Service",
  "common.goToDashboard": "Go to Dashboard",
  "common.language.ar": "Arabic",
  "common.language.en": "English",
  "common.language.zh": "Chinese (Simplified)",
  "common.learnMore": "Learn More",
  "common.loading": "Loading…",
  "common.logout": "Log Out",
  "profile.title": "Profile",
  "profile.fullName": "Full Name",
  "profile.email": "Email",
  "profile.role": "Role",
  "profile.vendorStatus": "Application Status",
  "profile.vendorStatus.pending_registration": "Pending Registration",
  "profile.vendorStatus.pending_application": "Pending Application",
  "profile.vendorStatus.pending_review": "Under Review",
  "profile.vendorStatus.approved": "Approved",
  "profile.vendorStatus.rejected": "Rejected",
  "profile.vendorStatus.update_required": "Update Required",
  "profile.section.account": "Account",
  "profile.section.preferences": "Preferences",
  "profile.submittedDocuments": "Submitted documents",
  "profile.changePassword": "Change password",
  "profile.changePassword.successToast": "Your password has been changed successfully. You can now log in with your new password.",
  "profile.changePassword.oldPasswordLabel": "Old Password",
  "profile.changePassword.oldPasswordPlaceholder": "Enter your old password",
  "profile.changePassword.submit": "Reset Password",
  "profile.getHelp": "Get help",
  "common.next": "Next",
  "common.noCountriesFound": "No countries found",
  "common.notifications": "Notifications",
  "common.optional": "Optional",
  "common.qrNotScanned": "QR code not yet scanned",
  "common.qrScanned": "QR code scanned",
  "common.relativeTime.daysFuture": "in {n} days",
  "common.relativeTime.daysPast": "{n} days ago",
  "common.relativeTime.hoursFuture": "in {n} hours",
  "common.relativeTime.hoursPast": "{n} hours ago",
  "common.relativeTime.justNow": "just now",
  "common.relativeTime.minutesFuture": "in {n} minutes",
  "common.relativeTime.minutesPast": "{n} minutes ago",
  "common.relativeTime.secondsFuture": "in {n} seconds",
  "common.relativeTime.secondsPast": "{n} seconds ago",
  "common.required": "Required",
  "common.rescanQR": "Scan Again",
  "common.save": "Save",
  "common.saveDraft": "Save Draft",
  "common.scanQR": "Scan QR Code",
  "common.search": "Search",
  "common.searchCountriesPlaceholder": "Search countries…",
  "common.selectFile": "Select File",
  "common.selectOption": "Select an option",
  "common.submit": "Submit",
  "common.table.empty.description": "There is currently no data available to display in this table.",
  "common.table.empty.title": "No data available",
  "common.table.showing": "Showing {from} to {to} of {total}",
  "common.uploadError": "Upload failed. Please try again.",
  "common.uploadSuccess": "Uploaded successfully",
  "common.uploading": "Uploading…",
  "common.view": "View",
  "countryDialCodePicker.a11y.code": "Country code: {flag} {dialCode}",
  "countryDialCodePicker.title": "Select country code",
  "countryPicker.a11y.country": "Country: {name}",
  "countryPicker.title": "Select country",
  "dev.logout": "DEV: Logout",
  "emptyState.description": "There are no items to display.",
  "emptyState.title": "Nothing here yet",
  "errorState.description": "An unexpected error occurred. Please try again.",
  "errorState.retry": "Try again",
  "errorState.title": "Something went wrong",
  "fileUpload.a11y.uploadFile": "Upload file",
  "fileUpload.acceptedFormats": "PDF, PNG or JPG (max. {maxSize}MB)",
  "fileUpload.acceptedFormatsNoSize": "PDF, PNG or JPG",
  "fileUpload.andAttachFiles": "and attach files",
  "fileUpload.clickToUpload": "Click to upload",
  "fileUpload.uploadFailed": "Upload failed. Tap to try again.",
  "fileUpload.viewDocument": "View document",
  "filePreview.error": "Unable to load preview",
  "filePreview.errorDescription": "The file could not be displayed. Please try again.",
  "filePreview.loading": "Loading preview…",
  "imageUpload.a11y.uploadImages": "Upload images",
  "imageUpload.addMore": "Add more images",
  "imageUpload.clickToUpload": "Click to upload",
  "imageUpload.maxImages": "PNG or JPG (max. {count} images)",
  "imageUpload.orDragAndDrop": "or drag and drop",
  "imageUpload.removeImage": "Remove image {index}",
  "imageUpload.uploading": "Uploading images…",
  "infoCard.approval.description": "Applications are typically reviewed within 1–2 business days after submission.",
  "infoCard.approval.title": "Quick Approval",
  "infoCard.assist.description": "Our onboarding team is available 9 AM – 6 PM CST to help you through the process.",
  "infoCard.assist.title": "Need Assistance?",
  "infoCard.secure.description": "Your data is encrypted and never shared with third parties without your consent.",
  "infoCard.secure.title": "Secure & Confidential",
  "invite.landing.invalidLink": "This invite link is invalid or has expired. Please contact your administrator.",
  "invite.landing.invalidLinkTitle": "Invalid Invitation",
  "invite.landing.mobileOption.hint": "We'll show you a QR Code to scan",
  "invite.landing.mobileOption.title": "Download Mobile App",
  "invite.landing.mobileOption.titleShort": "Download the app",
  "invite.landing.or": "or",
  "invite.landing.qrModal.subtitle": "Scan the QR code below with your phone",
  "invite.landing.qrModal.title": "Download The AladdinMiles App",
  "invite.landing.title": "You've been invited",
  "invite.landing.verifying": "Verifying your invitation…",
  "invite.landing.webOption.title": "Continue on Web",
  "l10n.dashboard.discardChanges": "Discard changes",
  "l10n.dashboard.empty": "No entries found.",
  "l10n.dashboard.language.ar": "Arabic",
  "l10n.dashboard.language.en": "English",
  "l10n.dashboard.language.zh-CN": "Chinese (Simplified)",
  "l10n.dashboard.saveChanges": "Save changes",
  "l10n.dashboard.title": "Localization Management",
  "language.ar": "العربية",
  "language.en": "English",
  "language.switcher.label": "Language",
  "language.zh-CN": "中文",
  "multiSelectPicker.allCategories": "All Categories",
  "multiSelectPicker.allIndustries": "All Industries",
  "multiSelectPicker.noResults": "No results found",
  "multiSelectPicker.remove": "Remove",
  "multiSelectPicker.saveSelection": "Save Selection",
  "multiSelectPicker.searchCategories": "Search category name",
  "multiSelectPicker.searchIndustries": "Search industry name",
  "multiSelectPicker.selectAll": "Select all",
  "multiSelectPicker.selectedCategories": "Selected Categories",
  "multiSelectPicker.selectedCategoriesCount": "You have selected {count} product categories",
  "multiSelectPicker.selectedIndustries": "Selected Industries",
  "multiSelectPicker.selectedIndustriesCount": "You have selected {count} industries",
  "multiSelectPicker.switchToChinese": "切换 Switch to Chinese",
  "multiSelectPicker.switchToEnglish": "ABC Switch to English",
  "notFound.description": "The page you are looking for does not exist or is unavailable.",
  "notFound.goHome": "Go to home",
  "notFound.heading": "Page not found",
  "notFound.screenTitle": "Not Found",
  "placeholder.activity.description": "You will see updates about your application and account here.",
  "placeholder.activity.title": "Activity",
  "placeholder.home.description": "Your overview dashboard will appear here.",
  "placeholder.home.title": "Home",
  "placeholder.profile.description": "Your profile settings will appear here.",
  "placeholder.profile.title": "Profile",
  "portal.dashboard.allInvitationsSent": "All Invitations Sent",
  "portal.dashboard.applications": "APPLICATIONS",
  "portal.dashboard.applicationsSubmitted": "Applications Submitted",
  "portal.dashboard.approved": "Approved",
  "portal.dashboard.filter.custom": "Custom",
  "portal.dashboard.filter.last24Hours": "Last 24 hours",
  "portal.dashboard.filter.last30Days": "Last 30 days",
  "portal.dashboard.filter.last7Days": "Last 7 days",
  "portal.dashboard.invitations": "INVITATIONS",
  "portal.dashboard.invited": "Invited",
  "portal.dashboard.newInvitations": "New Invitations",
  "portal.dashboard.overview": "Overview",
  "portal.dashboard.pendingReview": "Pending Review",
  "portal.dashboard.recentApplications": "Recent Applications",
  "portal.dashboard.rejected": "Rejected",
  "portal.dashboard.resentInvitations": "Resent Invitations",
  "portal.dashboard.reviewApplication": "Review Application",
  "portal.dashboard.subtitle": "Summary of activities across vendor applications and invitations.",
  "portal.dashboard.table.companyName": "Company Name",
  "portal.dashboard.table.lastActivity": "Last Activity",
  "portal.dashboard.table.primaryContact": "Primary Contact",
  "portal.dashboard.table.primaryIndustry": "Primary Industry",
  "portal.dashboard.table.status": "Status",
  "portal.dashboard.viewAllApplications": "View All Applications",
  "portal.nav.activity": "Activity",
  "portal.nav.adminUsers": "Admin Users",
  "portal.nav.application": "Application",
  "portal.nav.applications": "Applications",
  "portal.nav.home": "Home",
  "portal.nav.invitations": "Invitations",
  "portal.nav.overview": "Overview",
  "portal.nav.profile": "Profile",
  "preVetting.draftSaved": "Draft saved.",
  "preVetting.goBack": "Go back",
  "preVetting.step1.contactEmail": "Business email address",
  "preVetting.step1.contactPhone": "Contact phone",
  "preVetting.step1.contactPhonePlaceholder": "+86 000 0000 0000",
  "preVetting.step1.department": "Department",
  "preVetting.step1.error.idDocumentRequired": "ID document is required.",
  "preVetting.step1.error.invalidEmail": "Please enter a valid email address.",
  "preVetting.step1.error.invalidPhone": "Please enter a valid E.164 phone number.",
  "preVetting.step1.error.wechatQrNull": "WeChat QR string could not be parsed. Please scan again.",
  "preVetting.step1.idDocument": "ID document upload",
  "preVetting.step1.idType": "ID document type",
  "preVetting.step1.idType.nationalId": "Chinese National ID",
  "preVetting.step1.idType.passport": "Passport",
  "preVetting.step1.idType.other": "Other",
  "preVetting.step1.legalNameChinese": "Full legal name (Chinese)",
  "preVetting.step1.legalNameEnglish": "Full legal name (English)",
  "preVetting.step1.nationality": "Nationality",
  "preVetting.step1.nextLabel": "Add Business Information",
  "preVetting.step1.roleInCompany": "Role",
  "preVetting.step1.shortLabel": "Legal Representative",
  "preVetting.step1.subtitle": "Please provide the details of the authorized legal representative for your business.",
  "preVetting.step1.title": "Legal Representative & Contact",
  "preVetting.step1.wechatQr": "WeChat QR code",
  "preVetting.step2.businessLicense": "Business license",
  "preVetting.step2.companyNameArabic": "Company name (Arabic)",
  "preVetting.step2.companyNameArabicOptional": "Company name (Arabic) (Optional)",
  "preVetting.step2.companyNameChinese": "Company name (Chinese)",
  "preVetting.step2.companyNameEnglish": "Company name (English)",
  "preVetting.step2.error.businessLicenseRequired": "Business license document is required.",
  "preVetting.step2.error.taxNumberLength": "Must be 15–20 alphanumeric characters.",
  "preVetting.step2.error.unifiedCodeFormat": "USCC may only contain numbers and uppercase letters.",
  "preVetting.step2.error.unifiedCodeLength": "Must be exactly 18 alphanumeric characters.",
  "preVetting.step2.hqAddress": "Headquarters address",
  "preVetting.step2.hqCity": "City",
  "preVetting.step2.hqPostalCode": "Postal code",
  "preVetting.step2.nextLabel": "Add Product & Compliance",
  "preVetting.step2.sectionHqAddress": "Headquarters Address",
  "preVetting.step2.shortLabel": "Business Information",
  "preVetting.step2.subtitle": "Please provide the official registered details of your organization as they appear on legal documents.",
  "preVetting.step2.taxRegistrationNumber": "Tax registration number",
  "preVetting.step2.title": "Core Business Information",
  "preVetting.step2.unifiedSocialCreditCode": "Unified Social Credit Code",
  "preVetting.step3.addCategory": "Add category",
  "preVetting.step3.addIndustry": "Add industry",
  "preVetting.step3.ceMarking": "CE Marking",
  "preVetting.step3.ceMarkingHint": "EU health, safety, and environmental protection",
  "preVetting.step3.ceMarkingOptional": "CE Marking",
  "preVetting.step3.declaration": "I hereby declare that the information provided above is accurate and the uploaded documents are authentic. I understand that any false documentation may result in immediate suspension from the platform.",
  "preVetting.step3.ecoCertHint": "FSC, GOTS, or Fair Trade",
  "preVetting.step3.ecoCertification": "Eco Certifications",
  "preVetting.step3.ecoCertificationOptional": "Eco Certifications",
  "preVetting.step3.error.industryRequired": "Select at least one industry.",
  "preVetting.step3.error.subcategoryRequired": "Select at least one product category.",
  "preVetting.step3.industries": "Operating Industry (Select all that apply)",
  "preVetting.step3.industriesHint": "Select at least one industry.",
  "preVetting.step3.isoCertHint": "Proof of quality management systems",
  "preVetting.step3.isoCertification": "ISO 9001 Certificate",
  "preVetting.step3.isoCertificationOptional": "ISO 9001 Certificate",
  "preVetting.step3.nextLabel": "Add Financial Setup",
  "preVetting.step3.productSubcategories": "Product Category (Select all that apply)",
  "preVetting.step3.productSubcategoriesHint": "Select at least one product subcategory.",
  "preVetting.step3.qualityReportHint": "Recent third-party lab test results",
  "preVetting.step3.qualityTestReport": "Quality Test Reports",
  "preVetting.step3.qualityTestReportOptional": "Quality Test Reports",
  "preVetting.step3.sectionCompliance": "Compliance & Certifications",
  "preVetting.step3.shortLabel": "Product & Compliance",
  "preVetting.step3.subtitle": "Add the categories of products you intend to sell and upload your compliance certificates.",
  "preVetting.step3.title": "Product & Compliance",
  "preVetting.step4.alipay.accountEmail": "Alipay account email",
  "preVetting.step4.alipay.accountHolderName": "Account holder name",
  "preVetting.step4.alipay.isUnderLegalEntityName": "I confirm that this AliPay account is a corporate account belonging to the given account holder.",
  "preVetting.step4.alipay.merchantId": "Alipay merchant ID",
  "preVetting.step4.alipay.qrCode": "AliPay merchant QR code",
  "preVetting.step4.alipay.settlementCurrency": "Settlement currency",
  "preVetting.step4.alipay.title": "Alipay Details",
  "preVetting.step4.bank.accountHolderName": "Account holder name",
  "preVetting.step4.bank.accountNumber": "Account number",
  "preVetting.step4.bank.bankAddress": "Bank address",
  "preVetting.step4.bank.bankName": "Bank name",
  "preVetting.step4.bank.ibanCode": "IBAN",
  "preVetting.step4.bank.isUnderLegalEntityName": "I confirm that this account is a corporate account belonging to the given account holder.",
  "preVetting.step4.bank.settlementCurrency": "Settlement currency",
  "preVetting.step4.bank.swiftCode": "SWIFT / BIC code",
  "preVetting.step4.bank.title": "Bank Details",
  "preVetting.step4.bank.withdrawConsent": "Withdraw Payment Consent",
  "preVetting.step4.corporateAccountNote": "Please ensure your payment accounts are registered under the same legal entity name as your business.",
  "preVetting.step4.error.alipayRequired": "Alipay details are required when Alipay is selected.",
  "preVetting.step4.error.bankRequired": "Bank details are required when bank transfer is selected.",
  "preVetting.step4.error.channelRequired": "Select at least one payment channel.",
  "preVetting.step4.error.wechatPayRequired": "WeChat Pay details are required when WeChat Pay is selected.",
  "preVetting.step4.nextLabel": "Add Branding",
  "preVetting.step4.paymentChannels": "Payment channels",
  "preVetting.step4.paymentChannelsHint": "Select at least one payment channel.",
  "preVetting.step4.selectChannelsLabel": "Select the payment channels for you to receive payment",
  "preVetting.step4.shortLabel": "Financial Setup",
  "preVetting.step4.subtitle": "Provide your corporate financial information to enable settlement payments securely.",
  "preVetting.step4.title": "Financial Settlement",
  "preVetting.step4.wechatPay.accountEmail": "Account email",
  "preVetting.step4.wechatPay.accountHolderName": "Account holder name",
  "preVetting.step4.wechatPay.accountType": "Account type",
  "preVetting.step4.wechatPay.error.qrNull": "WeChat Pay QR string could not be parsed. Please scan again.",
  "preVetting.step4.wechatPay.merchantId": "WeChat Pay merchant ID",
  "preVetting.step4.wechatPay.qrCode": "WeChat Pay QR code",
  "preVetting.step4.wechatPay.settlementCurrency": "Settlement currency",
  "preVetting.step4.wechatPay.title": "WeChat Pay Details",
  "preVetting.step5.businessLogo": "Business logo",
  "preVetting.step5.descriptionArabic": "Business description (Arabic)",
  "preVetting.step5.descriptionArabicOptional": "Business description (Arabic) (Optional)",
  "preVetting.step5.descriptionEnglish": "Business description (English)",
  "preVetting.step5.error.descriptionTooShort": "Description must be at least 10 characters.",
  "preVetting.step5.error.logoRequired": "Business logo is required.",
  "preVetting.step5.primaryIndustry": "Primary industry",
  "preVetting.step5.shortLabel": "Branding & Localization",
  "preVetting.step5.shortNameArabic": "Short business name (Arabic)",
  "preVetting.step5.shortNameArabicOptional": "Short business name (Arabic) (Optional)",
  "preVetting.step5.shortNameEnglish": "Short business name (English)",
  "preVetting.step5.shortNameHint": "This will be your display name on the AladdinMiles customer app.",
  "preVetting.step5.subtitle": "Finalize your application by providing information about your business brand.",
  "preVetting.step5.title": "Branding & Localization",
  "preVetting.stepOf": "Step {current} of {total}",
  "preVetting.title": "Vendor Application",
  "preVetting.webSubtitle": "Fill in the details below and our team will assess your application",
  "preVetting.webTitle": "Apply to Become a Seller",
  "review.application.activityLog.actions.approved": "approved this application.",
  "review.application.activityLog.actions.rejected": "rejected this application.",
  "review.application.activityLog.actions.requested_updates": "requested updates to this application.",
  "review.application.activityLog.actions.resubmitted": "submitted updated application.",
  "review.application.activityLog.actions.submitted": "submitted this application.",
  "review.application.activityLog.empty": "No activity recorded for this application yet.",
  "review.application.activityLog.title": "Activity Log",
  "review.application.activityLog.viewRequest": "View Request",
  "review.application.activityLogComingSoon": "Activity log content coming soon.",
  "review.application.approve": "Approve",
  "review.application.status.approved": "Approved",
  "review.application.status.pending_review": "Pending Review",
  "review.application.status.rejected": "Rejected",
  "review.application.brandingLocalization.description": "Display name and brand assets.",
  "review.application.brandingLocalization.fields.businessLogo": "BUSINESS LOGO",
  "review.application.brandingLocalization.fields.descriptionArabic": "BUSINESS DESCRIPTION (ARABIC)",
  "review.application.brandingLocalization.fields.descriptionEnglish": "BUSINESS DESCRIPTION (ENGLISH)",
  "review.application.brandingLocalization.fields.shortNameArabic": "BUSINESS SHORT NAME (ARABIC)",
  "review.application.brandingLocalization.fields.shortNameChinese": "BUSINESS SHORT NAME (CHINESE)",
  "review.application.brandingLocalization.fields.shortNameEnglish": "BUSINESS SHORT NAME (ENGLISH)",
  "review.application.brandingLocalization.noLogo": "No logo uploaded",
  "review.application.brandingLocalization.notProvided": "Not provided",
  "review.application.brandingLocalization.title": "Branding & Localization",
  "review.application.businessInformation.description": "Official registered details of the business and operational information.",
  "review.application.businessInformation.fields.businessLicense": "BUSINESS LICENSE",
  "review.application.businessInformation.fields.city": "CITY",
  "review.application.businessInformation.fields.companyNameArabic": "COMPANY LEGAL NAME (ARABIC)",
  "review.application.businessInformation.fields.companyNameChinese": "COMPANY LEGAL NAME (CHINESE)",
  "review.application.businessInformation.fields.companyNameEnglish": "COMPANY LEGAL NAME (ENGLISH)",
  "review.application.businessInformation.fields.postalCode": "POSTAL CODE",
  "review.application.businessInformation.fields.registeredAddress": "REGISTERED OFFICE ADDRESS",
  "review.application.businessInformation.fields.taxRegistrationNumber": "TAX REGISTRATION NUMBER",
  "review.application.businessInformation.fields.ussc": "UNIFIED SOCIAL CREDIT CODE (USSC)",
  "review.application.businessInformation.notProvided": "Not provided",
  "review.application.businessInformation.title": "Business Information",
  "review.application.companyName": "Company",
  "review.application.contentComingSoon": "Content for {name} coming soon.",
  "review.application.edit": "Edit",
  "review.application.financialSettlement.description": "Corporate financial information for payment settlement. Some fields are masked for security.",
  "review.application.financialSettlement.fields.accountHolderName": "ACCOUNT HOLDER NAME",
  "review.application.financialSettlement.fields.alipayBusinessName": "ALIPAY REGISTERED BUSINESS NAME",
  "review.application.financialSettlement.fields.alipayEmail": "ALIPAY ACCOUNT EMAIL",
  "review.application.financialSettlement.fields.alipayMerchantId": "ALIPAY MERCHANT ID",
  "review.application.financialSettlement.fields.alipayQrCode": "ALIPAY PAYMENT QR CODE",
  "review.application.financialSettlement.fields.bankAccountNumber": "BANK ACCOUNT NUMBER",
  "review.application.financialSettlement.fields.bankAddress": "BANK ADDRESS",
  "review.application.financialSettlement.fields.bankName": "BANK NAME",
  "review.application.financialSettlement.fields.iban": "IBAN",
  "review.application.financialSettlement.fields.settlementCurrency": "SETTLEMENT CURRENCY",
  "review.application.financialSettlement.fields.swiftCode": "SWIFT CODE",
  "review.application.financialSettlement.fields.wechatBusinessName": "WECHAT PAY REGISTERED BUSINESS NAME",
  "review.application.financialSettlement.fields.wechatEmail": "WECHAT PAY ACCOUNT EMAIL",
  "review.application.financialSettlement.fields.wechatMerchantId": "WECHAT PAY MERCHANT ID",
  "review.application.financialSettlement.fields.wechatQrCode": "WECHAT PAY PAYMENT QR CODE",
  "review.application.financialSettlement.fields.wechatSettlementAccountType": "SETTLEMENT ACCOUNT TYPE",
  "review.application.financialSettlement.notProvided": "Not Provided",
  "review.application.financialSettlement.sections.alipay": "ALIPAY",
  "review.application.financialSettlement.sections.bank": "BANK",
  "review.application.financialSettlement.sections.wechatPay": "WECHAT PAY",
  "review.application.financialSettlement.showQrCode": "Show QR Code",
  "review.application.financialSettlement.title": "Financial Settlement",
  "review.application.legalRepresentative.description": "Personal and identification details of the authorized legal representative for this business",
  "review.application.legalRepresentative.fields.businessEmail": "BUSINESS EMAIL ADDRESS",
  "review.application.legalRepresentative.fields.department": "DEPARTMENT",
  "review.application.legalRepresentative.fields.fullNameChinese": "FULL LEGAL NAME (CHINESE)",
  "review.application.legalRepresentative.fields.fullNameEnglish": "FULL LEGAL NAME (ENGLISH)",
  "review.application.legalRepresentative.fields.legalId": "LEGAL REPRESENTATIVE ID",
  "review.application.legalRepresentative.fields.nationality": "NATIONALITY",
  "review.application.legalRepresentative.fields.phoneNumber": "PHONE NUMBER",
  "review.application.legalRepresentative.fields.role": "ROLE",
  "review.application.legalRepresentative.fields.wechatQr": "WECHAT QR CODE",
  "review.application.legalRepresentative.notUploaded": "Not Uploaded",
  "review.application.legalRepresentative.passport": "Passport",
  "review.application.legalRepresentative.passportPlaceholder": "Passport Image Placeholder",
  "review.application.legalRepresentative.title": "Legal Representative & Contact",
  "review.application.productCompliance.description": "Product categories, compliance certifications, and operating industries.",
  "review.application.productCompliance.fields.ceMarking": "CE MARKING",
  "review.application.productCompliance.fields.ecoCertifications": "ECO CERTIFICATIONS",
  "review.application.productCompliance.fields.isoCertificate": "ISO 9001 CERTIFICATE",
  "review.application.productCompliance.fields.operatingCategories": "OPERATING CATEGORIES",
  "review.application.productCompliance.fields.operatingIndustries": "OPERATING INDUSTRIES",
  "review.application.productCompliance.fields.qualityTestReports": "QUALITY TEST REPORTS",
  "review.application.productCompliance.notProvided": "Not provided",
  "review.application.productCompliance.title": "Product & Compliance",
  "review.application.productCompliance.viewDocument": "View document",
  "review.application.reject": "Reject",
  "review.application.rejectionDetails.dateRejected": "DATE REJECTED",
  "review.application.rejectionDetails.reason": "REASON",
  "review.application.rejectionDetails.rejectedBy": "REJECTED BY",
  "review.application.rejectionDetails.viewReason": "Reason for Rejection",
  "review.application.requestChanges": "Request Changes",
  "review.application.submittedAt": "Submitted",
  "review.application.subtabs.brandingLocalization": "Branding & Localization",
  "review.application.subtabs.businessInformation": "Business Information",
  "review.application.subtabs.financialSettlement": "Financial Settlement",
  "review.application.subtabs.legalRepresentative": "Legal Representative",
  "review.application.subtabs.productCompliance": "Product & Compliance",
  "review.application.tabs.activityLog": "Activity Log",
  "review.application.tabs.submittedInformation": "Submitted Information",
  "review.application.undoDecision": "Undo Decision",
  "review.dashboard.empty": "No applications pending review.",
  "review.dashboard.status.pendingReview": "Pending Review",
  "review.dashboard.title": "Vendor Applications",
  "review.review.decision.approve": "Approve Application",
  "review.review.decision.approveModal.checklist.brandAssets": "Brand assets and localization data are complete and meet marketplace guidelines",
  "review.review.decision.approveModal.checklist.businessRegistration": "Business registration and USSC have been cross-checked with official records",
  "review.review.decision.approveModal.checklist.complianceCertificates": "All compliance certificates are valid, current, and match the submitted categories",
  "review.review.decision.approveModal.checklist.financialSettlement": "Financial settlement credentials have been verified and the account is active",
  "review.review.decision.approveModal.checklist.legalIdentity": "Legal representative identity has been verified against submitted ID documents",
  "review.review.decision.approveModal.checklistNote": "Please complete all checklist items to enable approval.",
  "review.review.decision.approveModal.confirmApproval": "Confirm Approval",
  "review.review.decision.approveModal.successDescription": "This vendor will be notified by email that their application has been approved.",
  "review.review.decision.approveModal.successTitle": "Vendor Approved",
  "review.review.decision.approveModal.verificationChecklist": "Verification Checklist",
  "review.review.decision.description": "Choose a decision for the entire application.",
  "review.review.decision.reject": "Reject Application",
  "review.review.decision.rejectFieldModal.internalNote": "Internal Note",
  "review.review.decision.rejectFieldModal.internalNotePlaceholder": "This is for internal reference only and won't be visible to the vendor.",
  "review.review.decision.rejectFieldModal.reasonPlaceholder": "Does not match official records.",
  "review.review.decision.rejectFieldModal.rejectedFieldLabel": "REJECTED FIELD",
  "review.review.decision.rejectFieldModal.title": "Reject Selected Field",
  "review.review.decision.rejectModal.reasonForRejection": "Reason for Rejection",
  "review.review.decision.rejectModal.reasonPlaceholder": "Inconsistent company details across submitted documents.",
  "review.review.decision.rejectModal.rejectedVendor": "REJECTED VENDOR",
  "review.review.decision.rejectModal.submitRejection": "Submit Rejection",
  "review.review.decision.rejectModal.successDescription": "The vendor will be notified by email that their application has been rejected.",
  "review.review.decision.rejectModal.successTitle": "Application Rejected",
  "review.review.decision.requestChanges": "Request Changes",
  "review.review.decision.requestChangesModal.addReason": "Add reason",
  "review.review.decision.requestChangesModal.addReasons": "Add Reasons",
  "review.review.decision.requestChangesModal.back": "Back",
  "review.review.decision.requestChangesModal.fields.alipayBusinessName": "AliPay Registered Business Name",
  "review.review.decision.requestChangesModal.fields.alipayMerchantId": "AliPay Merchant ID",
  "review.review.decision.requestChangesModal.fields.businessLicense": "Business License",
  "review.review.decision.requestChangesModal.fields.businessLogo": "Business Logo",
  "review.review.decision.requestChangesModal.fields.ceMarking": "CE Marking",
  "review.review.decision.requestChangesModal.fields.companyNameEnglish": "Company Name (English)",
  "review.review.decision.requestChangesModal.fields.descriptionEnglish": "Business Description (English)",
  "review.review.decision.requestChangesModal.fields.ecoCertifications": "ECO Certifications",
  "review.review.decision.requestChangesModal.fields.isoCertificate": "ISO 9001 Certificate",
  "review.review.decision.requestChangesModal.fields.legalRepresentativeId": "Legal Representative ID",
  "review.review.decision.requestChangesModal.fields.operatingCategories": "Operating Categories",
  "review.review.decision.requestChangesModal.fields.operatingIndustries": "Operating Industries",
  "review.review.decision.requestChangesModal.fields.shortNameEnglish": "Business Short Name (English)",
  "review.review.decision.requestChangesModal.fields.taxRegistrationNumber": "Tax Registration Number",
  "review.review.decision.requestChangesModal.fields.unifiedSocialCreditCode": "Unified Social Credit Code",
  "review.review.decision.requestChangesModal.fields.wechatBusinessName": "WeChat Pay Registered Business Name",
  "review.review.decision.requestChangesModal.fields.wechatMerchantId": "WeChat Pay Merchant ID",
  "review.review.decision.requestChangesModal.fieldsSelected": "Fields Selected",
  "review.review.decision.requestChangesModal.noFieldsFound": "No fields match your search.",
  "review.review.decision.requestChangesModal.noFieldsSelectedHint": "Select fields from the left that need to be updated.",
  "review.review.decision.requestChangesModal.reasonLabel": "Reason",
  "review.review.decision.requestChangesModal.reasonPlaceholder": "Explain what needs to be corrected...",
  "review.review.decision.requestChangesModal.remove": "Remove",
  "review.review.decision.requestChangesModal.sendChangeRequest": "Send Change Request",
  "review.review.decision.requestChangesModal.step1Subtitle": "Step 1 of 2 (Select fields that need updating)",
  "review.review.decision.requestChangesModal.step2Subtitle": "Step 2 of 2 (Add a reason for each field)",
  "review.review.decision.requestChangesModal.submitRequest": "Submit Request",
  "review.review.decision.requestChangesModal.successDescription": "The vendor will be notified by email about the required changes for their application.",
  "review.review.decision.requestChangesModal.successTitle": "Changes Requested",
  "review.review.decision.requestChangesModal.title": "Request Changes",
  "review.review.decision.requestChangesModal.youHaveSelectedCount": "You have selected {count} fields",
  "review.review.decision.showDecisions": "Show Decisions",
  "review.review.decision.title": "Application Decision",
  "review.review.editFieldModal.currentValue": "Current Value",
  "review.review.editFieldModal.newValue": "New Value",
  "review.review.editFieldModal.saveAccept": "Save & Accept",
  "review.review.editFieldModal.title": "Edit Field",
  "review.review.fieldState.approved": "Approved",
  "review.review.fieldState.edited": "Edited",
  "review.review.fieldState.reasonModal.dateRejected": "DATE REJECTED",
  "review.review.fieldState.reasonModal.edit": "Edit",
  "review.review.fieldState.reasonModal.internalNote": "INTERNAL NOTE",
  "review.review.fieldState.reasonModal.reason": "REASON",
  "review.review.fieldState.reasonModal.rejectedBy": "REJECTED BY",
  "review.review.fieldState.reasonModal.title": "Reason for Rejection",
  "review.review.fieldState.rejected": "Rejected",
  "review.review.fieldState.showEdit": "Show Edit",
  "review.review.fieldState.showEditModal.currentValue": "Current Value",
  "review.review.fieldState.showEditModal.dateEdited": "DATE EDITED",
  "review.review.fieldState.showEditModal.editedBy": "EDITED BY",
  "review.review.fieldState.showEditModal.previousValue": "Previous Value",
  "review.review.fieldState.showEditModal.undoEdit": "Undo Edit",
  "review.review.fieldState.showEditModal.update": "Update",
  "review.review.fieldState.showReason": "Show Reason",
  "review.review.fieldState.undoDecision": "Undo Decision",
  "review.review.fieldsAudited": "{count} fields audited",
  "review.review.reviewCompleted": "Review Completed",
  "review.review.sectionProgress": "{current} of {total} sections",
  "review.review.title": "Review Application",
  "review.review.viewOnly": "VIEW ONLY",
  "roles.admin": "Admin",
  "roles.localizationStaff": "Localization Staff",
  "roles.staff": "Staff",
  "roles.superAdmin": "Super Admin",
  "roles.vendor": "Vendor",
  "staff.applications.stats.approved": "Approved Applications",
  "staff.applications.stats.approvedDesc": "Approved less than 24 hours ago",
  "staff.applications.stats.new": "New Applications",
  "staff.applications.stats.newDesc": "Submitted less than 24 hours ago",
  "staff.applications.stats.rejected": "Rejected Applications",
  "staff.applications.stats.rejectedDesc": "Rejected less than 24 hours ago",
  "staff.applications.subtitle": "Review and process submitted applications",
  "staff.applications.tabs.all": "All",
  "staff.applications.tabs.approved": "Approved",
  "staff.applications.tabs.pending": "Pending Review",
  "staff.applications.tabs.rejected": "Rejected",
  "staff.applications.title": "Vendor Applications",
  "staff.invitations.actions.resendInvite": "Resend Invite",
  "staff.invitations.actions.sendInvitation": "Send Invitation",
  "staff.invitations.detail.activityLog": "Activity Log",
  "staff.invitations.detail.activityResent": "{name} resent an invitation to this recipient.",
  "staff.invitations.detail.activitySent": "{name} sent an invitation to this recipient.",
  "staff.invitations.detail.breadcrumb": "Invitations",
  "staff.invitations.detail.invitationDetails": "Invitation Details",
  "staff.invitations.detail.lastInvitationDate": "LAST INVITATION DATE",
  "staff.invitations.detail.lastInvitedBy": "LAST INVITED BY",
  "staff.invitations.detail.quickTip": "Quick Tip",
  "staff.invitations.detail.quickTipBody": "If the recipient hasn't received the email, ask them to check their spam folder or confirm they have the right email address.",
  "staff.invitations.detail.recipientEmail": "RECIPIENT EMAIL ADDRESS",
  "staff.invitations.detail.recipientName": "RECIPIENT NAME",
  "staff.invitations.detail.resendCount": "RESEND COUNT",
  "staff.invitations.detail.resendInvite": "Resend Invite",
  "staff.invitations.detail.sentAgo": "Sent {time} ({date})",
  "staff.invitations.empty": "No invitations have been sent yet.",
  "staff.invitations.resend.body": "Are you sure you want to resend the invitation to {email}?",
  "staff.invitations.resend.cancel": "Cancel",
  "staff.invitations.resend.confirm": "Confirm",
  "staff.invitations.resend.languageLabel": "Invitation Language",
  "staff.invitations.resend.languagePlaceholder": "Select language",
  "staff.invitations.resend.success": "Invitation resent!",
  "staff.invitations.resend.successBody": "The invitation has been resent successfully.",
  "staff.invitations.resend.title": "Resend Invite",
  "staff.invitations.send.cancel": "Cancel",
  "staff.invitations.send.emailLabel": "Email Address",
  "staff.invitations.send.emailPlaceholder": "Enter vendor email address",
  "staff.invitations.send.firstNameLabel": "First Name (optional)",
  "staff.invitations.send.firstNamePlaceholder": "Enter first name",
  "staff.invitations.send.inviteVendorSubtitle": "A unique registration link will be sent to the recipient's email address",
  "staff.invitations.send.inviteVendorTitle": "Invite Vendor",
  "staff.invitations.send.languageLabel": "Invite Language",
  "staff.invitations.send.languagePlaceholder": "Select language",
  "staff.invitations.send.lastNameLabel": "Last Name (optional)",
  "staff.invitations.send.lastNamePlaceholder": "Enter last name",
  "staff.invitations.send.messageLabel": "Personal Message (optional)",
  "staff.invitations.send.messagePlaceholder": "Add a personal message to the invitation…",
  "staff.invitations.send.sendInvite": "Send Invite",
  "staff.invitations.send.submit": "Send Invitation",
  "staff.invitations.send.success": "Invitation sent!",
  "staff.invitations.send.successBody": "This recipient will receive an email with a unique registration link to begin their application.",
  "staff.invitations.send.title": "Send Invitation",
  "staff.invitations.stats.new": "New Invitations",
  "staff.invitations.stats.newDesc": "Sent less than 24 hours ago",
  "staff.invitations.stats.total": "Total Invitations",
  "staff.invitations.stats.totalDesc": "All invitations that have been sent",
  "staff.invitations.subtitle": "Manage and track invitations sent to vendors",
  "staff.invitations.table.dateInvited": "Date Invited",
  "staff.invitations.table.invitedBy": "Invited By",
  "staff.invitations.table.recipient": "Recipient",
  "staff.invitations.table.showing": "Showing {from} to {to} of {total}",
  "staff.invitations.tabs.all": "All Invitations",
  "staff.invitations.tabs.resent": "Resent Invitations",
  "staff.invitations.title": "Invitations",
  "staff.localization.actions.addContent": "Add Content",
  "staff.localization.actions.filter": "Filter",
  "staff.localization.actions.sort": "Sort",
  "staff.localization.addContent.arabicLabel": "Arabic Translation",
  "staff.localization.addContent.cancel": "Cancel",
  "staff.localization.addContent.chineseLabel": "Chinese Translation",
  "staff.localization.addContent.contentTypeCategories": "Product Categories",
  "staff.localization.addContent.contentTypeIndustries": "Product Industries",
  "staff.localization.addContent.contentTypeLabel": "Content Type",
  "staff.localization.addContent.contentTypeOther": "Other Content",
  "staff.localization.addContent.contentTypePlaceholder": "Select content type",
  "staff.localization.addContent.englishLabel": "English Translation",
  "staff.localization.addContent.infoText": "Adding all translations will move this content to completed.",
  "staff.localization.addContent.keyLabel": "Key Title",
  "staff.localization.addContent.keyPlaceholder": "e.g. common.save",
  "staff.localization.addContent.pending": "Pending",
  "staff.localization.addContent.submit": "Add Content",
  "staff.localization.addContent.success": "Content Added",
  "staff.localization.addContent.successBody": "You have successfully added a new content to the localization dictionary.",
  "staff.localization.addContent.error": "Failed to Add Content",
  "staff.localization.addContent.errorBody": "Something went wrong while adding the content. Please try again.",
  "staff.localization.addContent.title": "Add New Content",
  "staff.localization.addContent.translationsHeader": "Translations",
  "staff.localization.card.completed": "Completed",
  "staff.localization.card.lastEdited": "Last edited",
  "staff.localization.card.moreInfo": "More Info",
  "staff.localization.card.pending": "Pending",
  "staff.localization.detail.activityLog": "Activity Log",
  "staff.localization.detail.activityAction.add": "added a translation",
  "staff.localization.detail.activityAction.edit": "edited a translation",
  "staff.localization.detail.activityAction.delete": "deleted a translation",
  "staff.localization.detail.arabic": "Arabic",
  "staff.localization.detail.breadcrumb": "Localization",
  "staff.localization.detail.chinese": "Chinese",
  "staff.localization.detail.contentType": "CONTENT TYPE",
  "staff.localization.detail.contentTypeCategories": "Product Categories",
  "staff.localization.detail.contentTypeIndustries": "Product Industries",
  "staff.localization.detail.contentTypeOther": "Other Content",
  "staff.localization.detail.editTranslation": "Edit Translation",
  "staff.localization.detail.editTranslations": "Edit Translations",
  "staff.localization.detail.english": "English",
  "staff.localization.detail.keyTitle": "KEY TITLE",
  "staff.localization.detail.language": "LANGUAGE",
  "staff.localization.detail.title": "Translation Details",
  "staff.localization.detail.translation": "TRANSLATION",
  "staff.localization.filter.statusAll": "All",
  "staff.localization.filter.statusCompleted": "Completed",
  "staff.localization.filter.statusPending": "Pending",
  "staff.localization.filter.title": "STATUS",
  "staff.localization.modal.arabicLabel": "Arabic Translation",
  "staff.localization.modal.cancel": "Cancel",
  "staff.localization.modal.chineseLabel": "Chinese Translation",
  "staff.localization.modal.englishLabel": "English Translation",
  "staff.localization.modal.keyLabel": "KEY TITLE",
  "staff.localization.modal.save": "Save",
  "staff.localization.modal.saveSuccess": "Translation Saved!",
  "staff.localization.modal.saveSuccessBody": "You have successfully edited the translation.",
  "staff.localization.modal.saveError": "Failed to Save",
  "staff.localization.modal.saveErrorBody": "Something went wrong while saving the translation. Please try again.",
  "staff.localization.modal.title": "Edit Translation",
  "staff.localization.showing": "Showing {from} to {to} of {total}",
  "staff.localization.sort.alphaAsc": "Ascending (A-Z)",
  "staff.localization.sort.alphaDesc": "Descending (Z-A)",
  "staff.localization.sort.completionStatus": "Completion Status",
  "staff.localization.sort.keyName": "Key Name",
  "staff.localization.sort.lastEdited": "Last Edited",
  "staff.localization.sort.sectionAlpha": "ALPHABETICALLY",
  "staff.localization.sort.sectionDate": "DATE",
  "staff.localization.stats.allContent": "All Content",
  "staff.localization.stats.allContentDesc": "All content in the dictionary",
  "staff.localization.stats.completed": "Completed Localization",
  "staff.localization.stats.completedDesc": "Content with complete translations",
  "staff.localization.stats.pending": "Pending Localization",
  "staff.localization.stats.pendingDesc": "Content with missing translations",
  "staff.localization.subtitle": "Configure multilingual app content",
  "staff.localization.tabs.categories": "Product Categories",
  "staff.localization.tabs.completed": "Completed",
  "staff.localization.tabs.industries": "Product Industries",
  "staff.localization.tabs.other": "Other Content",
  "staff.localization.tabs.pending": "Pending",
  "staff.localization.title": "Localization",
  "staff.nav.adminUsers": "Admin Users",
  "staff.nav.applications": "Applications",
  "staff.nav.home": "Home",
  "staff.nav.invitations": "Invitations",
  "staff.nav.localization": "Localization",
  "staff.nav.profile": "Profile",
  "staff.users.actions.addNewUser": "Add New User",
  "staff.users.actions.deactivateUser": "Deactivate User",
  "staff.users.actions.reactivateUser": "Reactivate User",
  "staff.users.deactivate.title": "Deactivate User",
  "staff.users.deactivate.body": "Are you sure you want to deactivate {name}? They will no longer be able to log in.",
  "staff.users.deactivate.confirm": "Deactivate",
  "staff.users.deactivate.cancel": "Cancel",
  "staff.users.deactivate.success": "User Deactivated",
  "staff.users.deactivate.successBody": "The user's account has been deactivated and they can no longer log in.",
  "staff.users.reactivate.title": "Reactivate User",
  "staff.users.reactivate.body": "Are you sure you want to reactivate {name}? They will be able to log in again.",
  "staff.users.reactivate.confirm": "Reactivate",
  "staff.users.reactivate.cancel": "Cancel",
  "staff.users.reactivate.success": "User Reactivated",
  "staff.users.reactivate.successBody": "The user's account has been reactivated and they can now log in.",
  "staff.users.detail.activity.empty": "No activity found.",
  "staff.users.detail.activity.to": "to",
  "staff.users.detail.addedBy": "Added By",
  "staff.users.detail.adminInfo": "Administrative Information",
  "staff.users.detail.breadcrumb": "Admin Users",
  "staff.users.detail.dateAdded": "Date Added",
  "staff.users.detail.editUser": "Edit User",
  "staff.users.detail.emailAddress": "Email Address",
  "staff.users.detail.firstName": "First Name",
  "staff.users.detail.languagePreference": "Language Preference",
  "staff.users.detail.lastActivity": "Last Activity",
  "staff.users.detail.lastLogin": "Last login {time} ({date})",
  "staff.users.detail.lastModified": "Last Modified",
  "staff.users.detail.lastName": "Last Name",
  "staff.users.detail.personalInfo": "Personal Information",
  "staff.users.detail.phoneNumber": "Phone Number",
  "staff.users.detail.role": "Role",
  "staff.users.detail.tabs.activity": "Activity Log",
  "staff.users.detail.tabs.profile": "Profile Information",
  "staff.users.empty": "No users found.",
  "staff.users.modal.addButton": "Add User",
  "staff.users.modal.addSuccess": "Admin User Added",
  "staff.users.modal.addSuccessBody": "The user will receive an email to log in to their AladdinMiles account.",
  "staff.users.modal.addTitle": "Add New Admin User",
  "staff.users.modal.editSuccess": "Admin User Updated",
  "staff.users.modal.editSuccessBody": "The user's profile has been updated successfully.",
  "staff.users.modal.editTitle": "Edit Admin User",
  "staff.users.modal.rolePlaceholder": "Select a role",
  "staff.users.modal.saveButton": "Save Changes",
  "staff.users.stats.active": "Active Users",
  "staff.users.stats.activeDesc": "Currently active on the dashboard",
  "staff.users.stats.disabled": "Disabled Users",
  "staff.users.stats.disabledDesc": "Can no longer access the dashboard",
  "staff.users.stats.inactive": "Inactive Users",
  "staff.users.stats.inactiveDesc": "Currently inactive on the dashboard",
  "staff.users.subtitle": "Access team members and their roles",
  "staff.users.table.lastActivity": "Last Activity",
  "staff.users.table.role": "Role",
  "staff.users.table.status": "Status",
  "staff.users.table.user": "User",
  "staff.users.tabs.active": "Active",
  "staff.users.tabs.disabled": "Disabled",
  "staff.users.tabs.inactive": "Inactive",
  "staff.users.title": "Admin Users",
  "successState.description": "The action was completed successfully.",
  "successState.title": "Success",
  "toast.a11y.error": "Error",
  "toast.a11y.info": "Info",
  "toast.a11y.success": "Success",
  "ui.checkbox.defaultA11y": "Checkbox",
  "ui.login.showcaseA11y": "Open component showcase",
  "ui.tag.addA11y": "Add new item",
  "ui.tag.removeA11y": "Remove {label}",
  "vendor.application.companyInfo.dateApproved": "Date Approved",
  "vendor.application.companyInfo.dateSubmitted": "Date Submitted",
  "vendor.application.companyInfo.lastActivity": "Last Activity",
  "vendor.application.companyInfo.primaryIndustry": "Primary Industry",
  "vendor.application.detail.allFieldsApproved": "All fields have been approved",
  "vendor.application.detail.allFieldsReviewed": "All fields have been reviewed",
  "vendor.application.detail.allFieldsUnderReview": "All fields are under review",
  "vendor.application.detail.fieldRejected": "Rejected",
  "vendor.application.detail.fieldUpdateRequired": "Update Required",
  "vendor.application.detail.fieldUpdated": "Updated",
  "vendor.application.detail.fieldsFlaggedForUpdate": "field(s) in this section flagged for update",
  "vendor.application.detail.makeUpdate": "Make Update",
  "vendor.application.detail.notUploaded": "Not uploaded",
  "vendor.application.detail.showQrCode": "Show QR Code",
  "vendor.application.detail.tab.alipay": "AliPay",
  "vendor.application.detail.tab.bank": "Bank",
  "vendor.application.detail.tab.wechatPay": "WeChat Pay",
  "vendor.application.detail.financialSettlement.empty.title": "No settlement details",
  "vendor.application.detail.financialSettlement.empty.description": "No payment information was provided for this method.",
  "vendor.application.detail.viewDocument": "View document",
  "vendor.application.detail.viewImage": "View image",
  "vendor.application.stages.brandingLocalization": "Branding & Localization",
  "vendor.application.stages.businessInformation": "Business Information",
  "vendor.application.stages.completed": "Completed",
  "vendor.application.stages.financialSettlement": "Financial Settlement",
  "vendor.application.stages.inProgress": "In Progress",
  "vendor.application.stages.legalRepresentative": "Legal Representative",
  "vendor.application.stages.notStarted": "Not Started",
  "vendor.application.stages.productCompliance": "Product & Compliance",
  "vendor.application.stages.title": "APPLICATION STAGES",
  "vendor.application.stages.updateRequired": "Update Required",
  "vendor.application.subtitle": "Summary of each section of your application",
  "vendor.application.update.breadcrumb": "Update Submission",
  "vendor.application.update.confirmBody": "Are you sure the information you're about to submit is correct?",
  "vendor.application.update.confirmTitle": "Submit Update",
  "vendor.application.update.correction": "Correction",
  "vendor.application.update.correctionPlaceholder": "Enter the correct value",
  "vendor.application.update.newDocument": "New Document",
  "vendor.application.update.reviewerNote": "REVIEWER NOTE",
  "vendor.application.update.sectionTitle": "Update Submission",
  "vendor.application.update.submitUpdate": "Submit Update",
  "vendor.application.update.successDescription": "Your update has been submitted and our team will review it shortly.",
  "vendor.application.update.successTitle": "Update Submitted",
  "vendor.application.update.yesSubmit": "Yes, Submit",
  "vendor.application.update.yourSubmission": "Your Submission",
  "vendor.approved.body": "Congratulations! Your application has been approved.",
  "vendor.approved.contactSupport": "Need help? Contact support.",
  "vendor.approved.credentialsNote": "Use the email and password you set during registration.",
  "vendor.approved.portalLink": "Access Merchant Portal",
  "vendor.approved.title": "Application Approved",
  "vendor.dashboard.applicationStatus": "Your Application Status",
  "vendor.dashboard.approvedOn": "Approved {date}",
  "vendor.dashboard.approvedState.cta": "Go to Merchant Portal",
  "vendor.dashboard.approvedState.description": "Your vendor account is now active. You will receive a welcome email with onboarding steps.",
  "vendor.dashboard.approvedState.title": "Congratulations!",
  "vendor.dashboard.emptyState.description": "Your application is currently under review. We'll notify you once there are any updates.",
  "vendor.dashboard.emptyState.title": "Nothing to do right now",
  "vendor.dashboard.nav.activity": "Activity",
  "vendor.dashboard.nav.application": "Application",
  "vendor.dashboard.nav.home": "Home",
  "vendor.dashboard.nav.profile": "Profile",
  "vendor.dashboard.nextSteps.approved.01.description": "Use the button above or the link in your approval email to access the AladdinMiles merchant portal.",
  "vendor.dashboard.nextSteps.approved.01.title": "Log into Merchant Portal",
  "vendor.dashboard.nextSteps.approved.02.description": "Start adding products to the catalogue created for your business.",
  "vendor.dashboard.nextSteps.approved.02.title": "Add Products",
  "vendor.dashboard.nextSteps.approved.03.description": "Receive orders and fulfill them promptly to ensure customer satisfaction.",
  "vendor.dashboard.nextSteps.approved.03.title": "Fulfill Orders",
  "vendor.dashboard.nextSteps.decision.description": "You'll receive a notification with the final outcome.",
  "vendor.dashboard.nextSteps.decision.title": "Decision",
  "vendor.dashboard.nextSteps.review.description": "The team verifies your submitted documents and information",
  "vendor.dashboard.nextSteps.review.title": "Review",
  "vendor.dashboard.nextSteps.title": "Next Steps",
  "vendor.dashboard.nextSteps.validation.description": "Business registration and compliance certificates are cross-checked.",
  "vendor.dashboard.nextSteps.validation.title": "Validation",
  "vendor.dashboard.pendingUpdates.fieldsToUpdate": "{count} fields to update",
  "vendor.dashboard.pendingUpdates.title": "Pending Updates",
  "vendor.dashboard.pendingUpdates.noFieldsSpecified": "Your reviewer hasn't specified which fields need updating. Please contact them for clarification.",
  "vendor.dashboard.rejectedDocuments.rejected": "Rejected",
  "vendor.dashboard.rejectedDocuments.title": "REJECTED DOCUMENTS",
  "vendor.dashboard.rejectedDocuments.viewDocument": "View document",
  "vendor.dashboard.rejectedDocuments.viewReason": "View Reason",
  "vendor.dashboard.rejectedOn": "Rejected {date}",
  "vendor.dashboard.rejectedState.contactSupport": "Contact Support",
  "vendor.dashboard.rejectedState.defaultDescription": "Your application was not approved. Please contact support for more information.",
  "vendor.dashboard.rejectedState.title": "Reason for Rejection",
  "vendor.dashboard.status.approved": "Approved",
  "vendor.dashboard.status.notApproved": "Not Approved",
  "vendor.dashboard.status.pending": "Pending",
  "vendor.dashboard.status.updateRequired": "Update Required",
  "vendor.dashboard.step.approve": "Approve",
  "vendor.dashboard.step.review": "Review",
  "vendor.dashboard.step.submitted": "Submitted",
  "vendor.dashboard.submittedOn": "Submitted {date}",
  "vendor.dashboard.subtitle": "Here's what's happening with your application.",
  "vendor.dashboard.title": "Home",
  "vendor.landing.changeLanguage": "Change Language",
  "vendor.landing.contactSupport": "Contact Support",
  "vendor.landing.getStarted": "Get Started",
  "vendor.landing.needHelp": "Need Help?",
  "vendor.landing.subtitle": "Join the AladdinMiles exclusive vendor network and tap into the Saudi Arabian market.",
  "vendor.landing.title": "Scale Your Business with AladdinMiles",
  "vendor.languageSelect.appName": "AladdinMiles",
  "vendor.languageSelect.savePreference": "Save Preference",
  "vendor.languageSelect.title": "Select your preferred language",
  "vendor.languageSelect.welcomeTo": "Welcome to",
  "vendor.pendingReview.body": "Thanks for submitting your application. Our team is currently in the process of reviewing your application and will notify you by email when we have an update.",
  "vendor.pendingReview.contactTitle": "If you have any questions, please reach out to us through the following channels",
  "vendor.pendingReview.step.approveApplication": "Approve Application",
  "vendor.pendingReview.step.completed": "Completed",
  "vendor.pendingReview.step.createAccount": "Create Account",
  "vendor.pendingReview.step.pending": "Pending",
  "vendor.pendingReview.step.rejected": "Rejected",
  "vendor.pendingReview.step.rejectedApplication": "Rejected Application",
  "vendor.pendingReview.step.submitApplication": "Submit Application",
  "vendor.pendingReview.supportEmail": "vendor.support@aladdinmiles.com",
  "vendor.pendingReview.supportPhone": "+86 12345678901",
  "vendor.pendingReview.title": "We are reviewing your application",
  "vendor.rejected.body": "Unfortunately, your application was not approved at this time. Please check your email for details.",
  "vendor.rejected.title": "Application Not Approved",
  "vendor.activity.title": "Activity",
  "vendor.activity.subtitle": "Log of every update on your application",
  "vendor.activity.allActivities": "ALL ACTIVITIES",
  "vendor.activity.event.applicationApproved.title": "Application Approved",
  "vendor.activity.event.applicationApproved.description": "Your application has been reviewed and approved.",
  "vendor.activity.event.applicationRejected.title": "Application Not Approved",
  "vendor.activity.event.applicationRejected.description": "Your application has been reviewed and was not approved.",
  "vendor.activity.event.applicationReceived.title": "Application Received",
  "vendor.activity.event.applicationReceived.description": "All five sections have been submitted",
  "vendor.activity.event.updateRequired.title": "Update Required",
  "vendor.activity.event.updateRequired.description": "Fields need your attention before the review can continue.",
  "vendor.activity.event.updateSubmitted.title": "Update Submitted",
  "vendor.activity.event.updateSubmitted.description": "Your update has been submitted"
}
